
import api from '@/api'

// 登录（密码）
export function login(data) {
    return api({
        url: '/api/agent/auth/pwdLogin',
        method: 'post',
        data
    })
}

// 权限
export function getPermission(params) {
    return api({
        url: '/api/system/getInfo',
        method: 'get',
        params
    })
}

// 权限
export function getUserInfo(params) {
    return api({
        url: '/api/agent/agent/profile',
        method: 'get',
        params
    })
}

// 忘记密码
export function forgetPassword(data) {
    return api({
        url: '/api/agent/auth/resetLoginPwd',
        method: 'put',
        data
    })
}

// 发送短信
export function sendSms(data) {
    return api({
        url: '/api/common/sms/sendCode',
        method: 'post',
        data
    })
}

// 是否需要图形验证码
export function checkCaptcha(params) {
    return api({
        url: '/api/common/captcha/checkAccount',
        method: 'get',
        params
    })
}

// 获取最新版本
export function latestVersion(params) {
    return api({
        url: '/api/common/system/latestVersion',
        method: 'get',
        params
    })
}
